import styled from 'styled-components';

const backgroundColor = (props) => {
  if (props.isTake) return '#FBCC08';
  if (props.okayToSell) return '#21BA45';
  if (props.disabled) return '#e7e7e7';
  if (props.doNotSell) return '#DB2828';
  return '#BCEAFD';
};

const color = (props) => {
  if (props.isTake) return '#000';
  if (props.okayToSell) return '#FFF';
  if (props.disabled) return '#666';
  if (props.doNotSell) return '#FFF';
  return '#000';
};

export const Container = styled.div`
  background-color: ${(props) => backgroundColor(props)};
  color: ${(props) => color(props)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  border: 1px solid gray;
  height: 175px;
  & h1 {
    margin: ${(props) => (props.okayToSell || props.doNotSell ? '0px 8px' : '8px')};
    font-size: 2.3em;
  }
`;

export const AskingBidLabel = styled.h1`
  margin: 0px 8px;
  font-size: 2.3em;
`;

export const OkayToSell = styled.h2`
  margin: 8px;
  font-size: 1.6em;
  border-top: 1px solid ${(props) => color(props)};
  padding-top: 10px;
  text-align: center;
`;
